import { Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MelioMeSVG } from '@tools/ui/assets';

const MelioMeIcon: React.FC<React.PropsWithChildren> = () => {
  const { t } = useTranslation();
  return (
    <Tooltip placement="top" title={t('icons.melioMe')}>
      <MelioMeSVG
        style={{ width: 20, height: 20, display: 'flex', alignItems: 'center' }}
      />
    </Tooltip>
  );
};

export default MelioMeIcon;
